
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Activity, Cell, Line, Media } from '../backend/backendapi';

@Component({
  components: {
    ImageViewer: require('../imageviewer/imageviewer.vue.html').default,
  },
})
export default class TabCell extends Vue {
  @Prop({ required: true })
  readonly activity!: Activity;
  @Prop({ required: true })
  readonly cell!: Cell | null;
  @Prop({ required: true })
  readonly line!: Line | null;

  cellMoreDetails: boolean = false;

  get medias(): Media[] {
    return this.cell?.files ?? [];
  }

  get isCellMedia(): boolean {
    return !!this.cell
        && this.cell.files !== undefined
        && this.cell.files.length > 0;
  };
}
